import { useState, useEffect, useRef } from 'react';
import Layout from '../components/Layout';
import { implementacionesApi, crearImplementacionApi, actualizarImplementacionApi, actualizarEtapaApi, implementacionApi, usuariosApi, subirArchivoImplApi, eliminarArchivoApi, urlArchivo } from '../api';

const TIPOS = [
  { value: 'vuepacs_carestream', label: 'VUEPACS Carestream' },
  { value: 'vuepacs_philips',    label: 'VUEPACS Philips' },
  { value: 'otro',               label: 'Otro' },
];

const ESTADOS = [
  { value: 'planificada', label: 'Planificada', color: '#4a9fd4', bg: '#0f1e35' },
  { value: 'en_curso',    label: 'En curso',    color: '#fbbf24', bg: '#2e2010' },
  { value: 'finalizada',  label: 'Finalizada',  color: '#4ade80', bg: '#0f2e15' },
  { value: 'pausada',     label: 'Pausada',     color: '#f87171', bg: '#3a1010' },
];

const ESTADOS_ETAPA = [
  { value: 'pendiente',  label: 'Pendiente',  color: '#666' },
  { value: 'en_curso',   label: 'En curso',   color: '#fbbf24' },
  { value: 'completada', label: 'Completada', color: '#4ade80' },
  { value: 'n_a',        label: 'N/A',        color: '#888' },
];

const inp = { width: '100%', padding: '10px 13px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' };
const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 5 };

function Toggle({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #eee' }}>
      <span style={{ fontSize: 13, color: '#333' }}>{label}</span>
      <button type="button" onClick={() => onChange(!value)} style={{ width: 40, height: 22, borderRadius: 999, border: 'none', cursor: 'pointer', background: value ? '#1a6fbb' : '#ddd', position: 'relative', transition: 'background 0.2s' }}>
        <div style={{ width: 16, height: 16, borderRadius: '50%', background: '#fff', position: 'absolute', top: 3, transition: 'left 0.2s', left: value ? 21 : 3 }}/>
      </button>
    </div>
  );
}

const formVacio = {
  cliente_id: '', cliente_nombre_libre: '', titulo: '', tipo: 'vuepacs_philips', responsable_id: '',
  fecha_inicio: '', fecha_fin_estimada: '', descripcion: '',
  modulo_his: false, modulo_eis: false, modulo_vuemotion: false,
  modulo_myvue: false, modulo_portal_paciente: false, portal_proveedor: ''
};

export default function Implementaciones() {
  const [implementaciones, setImplementaciones] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState(false);
  const [detalle, setDetalle] = useState(null);
  const [form, setForm] = useState(formVacio);
  const [guardando, setGuardando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [tabDetalle, setTabDetalle] = useState('etapas');
  const [subiendo, setSubiendo] = useState(false);
  const fileRef = useRef(null);

  const cargar = async () => {
    setCargando(true);
    try {
      const [i, u] = await Promise.all([implementacionesApi(), usuariosApi()]);
      setImplementaciones(i.data);
      setUsuarios(u.data.filter(u => u.activo));
    } catch(err) { console.error(err); }
        finally { setCargando(false); }
  };

  useEffect(() => { cargar(); }, []);

  const abrirDetalle = async (id) => {
    try {
      const r = await implementacionApi(id);
      setDetalle(r.data);
      setTabDetalle('etapas');
    } catch(err) { console.error(err); }
  };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await crearImplementacionApi(form);
      setModal(false);
      setForm(formVacio);
      cargar();
    } catch(err) {
      alert(err.response?.data?.error || 'Error al guardar');
    } finally { setGuardando(false); }
  };

  const actualizarEtapa = async (implId, etapaId, data) => {
    try {
      await actualizarEtapaApi(implId, etapaId, data);
      const r = await implementacionApi(implId);
      setDetalle(r.data);
      cargar();
    } catch(err) { alert('Error al actualizar etapa'); }
  };

  const cambiarEstadoImpl = async (id, estado) => {
    try {
      const impl = implementaciones.find(i => i.id === id);
      await actualizarImplementacionApi(id, { ...impl, estado });
      cargar();
      if (detalle?.id === id) setDetalle({ ...detalle, estado });
    } catch(err) { alert('Error al cambiar estado'); }
  };

  const subirArchivo = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length || !detalle) return;
    setSubiendo(true);
    try {
      const fd = new FormData();
      files.forEach(file => fd.append('archivo', file));
      await subirArchivoImplApi(detalle.id, fd);
      const r = await implementacionApi(detalle.id);
      setDetalle(r.data);
    } catch(err) { alert('Error al subir archivo'); }
    finally { setSubiendo(false); }
  };

  const eliminarArchivo = async (filename) => {
    if (!window.confirm('Eliminar este archivo?')) return;
    try {
      await eliminarArchivoApi(filename);
      const r = await implementacionApi(detalle.id);
      setDetalle(r.data);
    } catch(err) { alert('Error al eliminar'); }
  };

  const estadoInfo = (e) => ESTADOS.find(x => x.value === e) || ESTADOS[0];
  const esImagen = (tipo) => tipo?.startsWith('image/');

  const filtradas = implementaciones.filter(i =>
    i.titulo?.toLowerCase().includes(busqueda.toLowerCase()) ||
    i.cliente_nombre?.toLowerCase().includes(busqueda.toLowerCase())
  );

  const tabStyle = (activo) => ({
    padding: '8px 16px', fontSize: 13, fontWeight: activo ? 600 : 400,
    color: activo ? '#4a9fd4' : '#666', background: 'none', border: 'none',
    borderBottom: activo ? '2px solid #4a9fd4' : '2px solid transparent', cursor: 'pointer'
  });

  return (
    <Layout titulo="Implementaciones">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: 8 }}>
        <p style={{ fontSize: 20, fontWeight: 600, color: '#fff' }}>Implementaciones</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input style={{ width: 220, padding: '8px 12px', border: '1px solid #2a2a2a', borderRadius: 8, background: '#1a1a1a', color: '#fff', fontSize: 14, outline: 'none' }} placeholder="Buscar..." value={busqueda} onChange={e => setBusqueda(e.target.value)}/>
          <button className="btn btn-primary" onClick={() => { setForm(formVacio); setModal(true); }}>+ Nueva implementacion</button>
        </div>
      </div>

      {cargando ? (
        <p style={{ textAlign: 'center', color: '#555', padding: '2rem' }}>Cargando...</p>
      ) : filtradas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#555' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🔧</div>
          <p>No hay implementaciones cargadas</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 }}>
          {filtradas.map(i => {
            const est = estadoInfo(i.estado);
            const progreso = i.etapas_total > 0 ? Math.round((i.etapas_completadas / i.etapas_total) * 100) : 0;
            return (
              <div key={i.id} style={{ background: '#141414', border: '1px solid #222', borderRadius: 12, padding: '1.25rem', cursor: 'pointer' }} onClick={() => abrirDetalle(i.id)}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 15, color: '#fff', marginBottom: 4 }}>{i.titulo}</div>
                    <div style={{ fontSize: 12, color: '#888' }}>{i.cliente_nombre || 'Sin cliente asignado'}</div>
                  </div>
                  <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 999, background: est.bg, color: est.color, fontWeight: 600, flexShrink: 0, marginLeft: 8 }}>{est.label}</span>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#aaa', marginBottom: 5 }}>
                    <span>Progreso</span>
                    <span style={{ color: '#fff', fontWeight: 600 }}>{i.etapas_completadas}/{i.etapas_total} etapas</span>
                  </div>
                  <div style={{ background: '#1a1a1a', borderRadius: 999, height: 6, overflow: 'hidden' }}>
                    <div style={{ height: '100%', borderRadius: 999, background: progreso === 100 ? '#4ade80' : '#1a6fbb', width: `${progreso}%`, transition: 'width 0.3s' }}/>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 10 }}>
                  {[['HIS', i.modulo_his], ['EIS', i.modulo_eis], ['VueMotion', i.modulo_vuemotion], ['MyVue', i.modulo_myvue], ['Portal', i.modulo_portal_paciente]].map(([label, val]) =>
                    val ? <span key={label} style={{ fontSize: 11, padding: '2px 7px', borderRadius: 999, background: '#0f2e15', color: '#4ade80', fontWeight: 500 }}>{label}</span> : null
                  )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#555' }}>
                  <span>{i.responsable_nombre ? `${i.responsable_nombre} ${i.responsable_apellido}` : 'Sin responsable'}</span>
                  {i.fecha_inicio && <span>{new Date(i.fecha_inicio).toLocaleDateString('es-AR')}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '1rem', overflowY: 'auto' }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: '1.75rem', width: '100%', maxWidth: 560, maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
              <p style={{ fontWeight: 700, fontSize: 16, color: '#111' }}>Nueva implementacion</p>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }}>✕</button>
            </div>
            <form onSubmit={guardar}>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Titulo *</label>
                <input type="text" placeholder="ej: Implementacion VUEPACS Hospital Britanico" value={form.titulo} onChange={e => setForm({ ...form, titulo: e.target.value })} required style={inp}/>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Cliente / Institucion</label>
                  <input type="text" placeholder="Nombre de la institucion..." value={form.cliente_nombre_libre || ''} onChange={e => setForm({ ...form, cliente_nombre_libre: e.target.value, cliente_id: '' })} style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Tipo</label>
                  <select value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })} style={inp}>
                    {TIPOS.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Responsable</label>
                <select value={form.responsable_id} onChange={e => setForm({ ...form, responsable_id: e.target.value })} style={inp}>
                  <option value="">Sin asignar</option>
                  {usuarios.map(u => <option key={u.id} value={u.id}>{u.nombre} {u.apellido}</option>)}
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Fecha inicio</label>
                  <input type="date" value={form.fecha_inicio} onChange={e => setForm({ ...form, fecha_inicio: e.target.value })} style={inp}/>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label style={lbl}>Fecha fin estimada</label>
                  <input type="date" value={form.fecha_fin_estimada} onChange={e => setForm({ ...form, fecha_fin_estimada: e.target.value })} style={inp}/>
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Descripcion</label>
                <textarea rows={3} value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })} style={inp}/>
              </div>
              <div style={{ marginBottom: 16 }}>
                <p style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 10 }}>Modulos a implementar</p>
                <Toggle label="HIS — Historia Clinica Integrada"   value={form.modulo_his}             onChange={v => setForm({ ...form, modulo_his: v })}/>
                <Toggle label="EIS — Sistema MWKS Philips"         value={form.modulo_eis}             onChange={v => setForm({ ...form, modulo_eis: v })}/>
                <Toggle label="VueMotion"                          value={form.modulo_vuemotion}       onChange={v => setForm({ ...form, modulo_vuemotion: v })}/>
                <Toggle label="MyVue (Philips)"                    value={form.modulo_myvue}           onChange={v => setForm({ ...form, modulo_myvue: v })}/>
                <Toggle label="Portal Paciente independiente"      value={form.modulo_portal_paciente} onChange={v => setForm({ ...form, modulo_portal_paciente: v })}/>
                {form.modulo_portal_paciente && (
                  <div style={{ marginTop: 10 }}>
                    <label style={lbl}>Proveedor del portal</label>
                    <input type="text" placeholder="ej: Pixelmed, Ambra..." value={form.portal_proveedor} onChange={e => setForm({ ...form, portal_proveedor: e.target.value })} style={inp}/>
                  </div>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button type="button" onClick={() => setModal(false)} style={{ padding: '9px 20px', background: 'transparent', color: '#333', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, cursor: 'pointer' }}>Cancelar</button>
                <button type="submit" disabled={guardando} style={{ padding: '9px 20px', background: '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                  {guardando ? 'Creando...' : 'Crear implementacion'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {detalle && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end', zIndex: 1000 }}>
          <div style={{ background: '#141414', width: '100%', maxWidth: 540, height: '100vh', overflowY: 'auto', borderLeft: '1px solid #222', padding: '1.75rem' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
              <div>
                <p style={{ fontWeight: 700, fontSize: 16, color: '#fff' }}>{detalle.titulo}</p>
                <p style={{ fontSize: 13, color: '#888', marginTop: 3 }}>{detalle.cliente_nombre || 'Sin cliente'}</p>
              </div>
              <button onClick={() => setDetalle(null)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#555' }}>✕</button>
            </div>

            <div style={{ display: 'flex', gap: 8, marginBottom: '1rem', flexWrap: 'wrap' }}>
              {ESTADOS.map(e => (
                <button key={e.value} onClick={() => cambiarEstadoImpl(detalle.id, e.value)} style={{ padding: '5px 12px', borderRadius: 999, border: `1px solid ${detalle.estado === e.value ? e.color : '#333'}`, background: detalle.estado === e.value ? e.bg : 'transparent', color: detalle.estado === e.value ? e.color : '#555', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {e.label}
                </button>
              ))}
            </div>

            <div style={{ background: '#1a1a1a', borderRadius: 10, padding: '1rem', marginBottom: '1rem', fontSize: 13 }}>
              {[
                ['Tipo', TIPOS.find(t => t.value === detalle.tipo)?.label],
                ['Responsable', detalle.responsable_nombre ? `${detalle.responsable_nombre} ${detalle.responsable_apellido}` : '—'],
                ['Inicio', detalle.fecha_inicio ? new Date(detalle.fecha_inicio).toLocaleDateString('es-AR') : '—'],
                ['Fin estimado', detalle.fecha_fin_estimada ? new Date(detalle.fecha_fin_estimada).toLocaleDateString('es-AR') : '—'],
              ].map(([k, v]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: '1px solid #222' }}>
                  <span style={{ color: '#666' }}>{k}</span>
                  <span style={{ color: '#ddd' }}>{v}</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', borderBottom: '1px solid #222', marginBottom: '1rem' }}>
              <button style={tabStyle(tabDetalle === 'etapas')}   onClick={() => setTabDetalle('etapas')}>Etapas</button>
              <button style={tabStyle(tabDetalle === 'adjuntos')} onClick={() => setTabDetalle('adjuntos')}>
                Adjuntos {detalle.archivos?.length > 0 && <span style={{ background: '#1a6fbb', color: '#fff', fontSize: 10, padding: '1px 6px', borderRadius: 999, marginLeft: 4 }}>{detalle.archivos.length}</span>}
              </button>
              {detalle.descripcion && <button style={tabStyle(tabDetalle === 'info')} onClick={() => setTabDetalle('info')}>Info</button>}
            </div>

            {tabDetalle === 'etapas' && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {detalle.etapas?.map(etapa => {
                  const est = ESTADOS_ETAPA.find(e => e.value === etapa.estado);
                  return (
                    <div key={etapa.id} style={{ background: '#1a1a1a', borderRadius: 10, padding: '12px 14px', border: `1px solid ${etapa.estado === 'completada' ? '#0f2e15' : '#222'}` }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <span style={{ fontSize: 13, color: '#fff', fontWeight: 500 }}>
                          {etapa.estado === 'completada' ? '✅' : etapa.estado === 'en_curso' ? '🔄' : etapa.estado === 'n_a' ? '➖' : '⏳'} {etapa.nombre}
                        </span>
                        <select value={etapa.estado} onChange={e => actualizarEtapa(detalle.id, etapa.id, { estado: e.target.value, notas: etapa.notas })} style={{ padding: '3px 8px', borderRadius: 6, border: '1px solid #333', background: '#111', color: est?.color || '#aaa', fontSize: 12, outline: 'none', cursor: 'pointer' }}>
                          {ESTADOS_ETAPA.map(e => <option key={e.value} value={e.value}>{e.label}</option>)}
                        </select>
                      </div>
                      {etapa.fecha_completado && (
                        <div style={{ fontSize: 11, color: '#4ade80', marginBottom: 4 }}>
                          Completada el {new Date(etapa.fecha_completado).toLocaleDateString('es-AR')}
                        </div>
                      )}
                      <textarea placeholder="Notas de esta etapa..." defaultValue={etapa.notas || ''} onBlur={e => actualizarEtapa(detalle.id, etapa.id, { estado: etapa.estado, notas: e.target.value })}
                        style={{ width: '100%', padding: '6px 10px', border: '1px solid #2a2a2a', borderRadius: 6, background: '#111', color: '#aaa', fontSize: 12, outline: 'none', resize: 'vertical', marginTop: 4 }} rows={2}/>
                    </div>
                  );
                })}
              </div>
            )}

            {tabDetalle === 'adjuntos' && (
              <>
                <div onClick={() => fileRef.current?.click()}
                  style={{ border: '1.5px dashed #2a2a2a', borderRadius: 10, padding: '20px', textAlign: 'center', cursor: 'pointer', marginBottom: 16, background: '#1a1a1a' }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = '#1a6fbb'}
                  onMouseLeave={e => e.currentTarget.style.borderColor = '#2a2a2a'}>
                  <div style={{ fontSize: 24, marginBottom: 6 }}>📎</div>
                  <p style={{ fontSize: 13, color: '#888' }}>{subiendo ? 'Subiendo...' : 'Hace clic para adjuntar archivos'}</p>
                  <p style={{ fontSize: 11, color: '#555', marginTop: 4 }}>JPG, PNG, PDF, DOC, XLS — max. 10MB</p>
                </div>
                <input ref={fileRef} type="file" style={{ display: 'none' }} onChange={subirArchivo} accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.doc,.docx,.xls,.xlsx,.txt" multiple/>
                {!detalle.archivos?.length ? (
                  <p style={{ textAlign: 'center', color: '#555', fontSize: 13, padding: '1rem 0' }}>No hay archivos adjuntos</p>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {detalle.archivos.map(a => (
                      <div key={a.id} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#1a1a1a', borderRadius: 8, padding: '10px 12px', border: '1px solid #222' }}>
                        <span style={{ fontSize: 20 }}>{esImagen(a.tipo_archivo) ? '🖼' : a.tipo_archivo?.includes('pdf') ? '📄' : '📎'}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, color: '#fff', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{a.nombre_original}</div>
                          <div style={{ fontSize: 11, color: '#555' }}>{(a.tamanio / 1024).toFixed(1)} KB · {a.subido_por_nombre || 'Sistema'} · {new Date(a.created_at).toLocaleDateString('es-AR')}</div>
                        </div>
                        <a href={urlArchivo(a.nombre_archivo)} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#4a9fd4', textDecoration: 'none', padding: '4px 8px', border: '1px solid #4a9fd4', borderRadius: 6 }}>Ver</a>
                        <button onClick={() => eliminarArchivo(a.nombre_archivo)} style={{ fontSize: 12, color: '#f87171', background: 'none', border: '1px solid #f87171', borderRadius: 6, padding: '4px 8px', cursor: 'pointer' }}>✕</button>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            {tabDetalle === 'info' && detalle.descripcion && (
              <div style={{ background: '#1a1a1a', borderRadius: 10, padding: '1rem' }}>
                <p style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Descripcion general</p>
                <p style={{ fontSize: 13, color: '#aaa', lineHeight: 1.6 }}>{detalle.descripcion}</p>
              </div>
            )}
          </div>
        </div>
      )}
    </Layout>
  );
}